import { IGraphicInfo, IGraphicData } from '../types/graphics';

export const filteredDataGraphic = (
  payload: IGraphicData,
  selected: string
) => {
  const { info } = payload;

  const filteredPayload = info
    .map(({ name, data }) => {
      const filteredSubItems = data.filter((subItem) =>
        subItem.filter.includes(selected)
      );

      if (filteredSubItems?.length > 0) {
        return {
          name,
          data: filteredSubItems,
        };
      }
      return null;
    })
    .filter(Boolean) as IGraphicInfo[];

  return filteredPayload;
};
